module.exports = __webpack_public_path__ + "static/img/AIMicroTable.6572ef84.png";